<template>
  <div class="sign-up-login-menu-and-buttons">
    <!-- Sign in and sign up buttons & bigger screens -->
    <v-toolbar-items v-show="!loggedIn && !breakpoint.smAndDown">
      <v-btn flat dark @click="showSignUpDialog = true">Sign Up</v-btn>
      <v-btn flat dark @click="showLogInDialog = true">Log In</v-btn>
    </v-toolbar-items>

    <!-- Log in and sign up burger menu for mobile  -->

    <v-menu
      v-show="!loggedIn && breakpoint.smOnly"
      offset-y
      nudge-bottom="6"
      min-width="240"
      :close-on-content-click="true"
    >
      <v-btn slot="activator" icon dark>
        <v-icon medium>view_headline</v-icon>
      </v-btn>

      <v-card>
        <v-list>
          <v-list-tile @click="showSignUpDialog = true">
            <v-list-tile-action>
              <v-icon>person_add</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Sign up</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="showLogInDialog = true">
            <v-list-tile-action>
              <v-icon>login</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Log in</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
    
    
    <!-- Log in, sign up menu bottom sheet -->

    <v-bottom-sheet v-show="!loggedIn && breakpoint.xsOnly" v-model="showLoginSignupBottomSheet">
      <template v-slot:activator>
        <v-btn icon dark>
          <v-icon medium>view_headline</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile @click="showSignUpDialog = true; showLoginSignupBottomSheet = false;">
          <v-list-tile-action>
            <v-icon>person_add</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Sign up</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="showLogInDialog = true; showLoginSignupBottomSheet = false;">
          <v-list-tile-action>
            <v-icon>login</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Log in</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: 'signUpLoginMenuAndButtons',
  data() {
    return {

    }
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    loggedIn() {
      return this.$store.getters.getUser;
    },
    showSignUpDialog: {
      get() {
        return this.$store.getters.getShowSignUpDialog;
      },
      set(value) {
        this.$store.dispatch('setShowSignUpDialog', value);
      }
    },
    showLogInDialog: {
      get() {
        return this.$store.getters.getShowLogInDialog;
      },
      set(value) {
        this.$store.dispatch('setShowLogInDialog', value);
      }
    },
    showLoginSignupBottomSheet: {
      get() {
        return this.$store.getters.getShowLoginSignupBottomSheet;
      },
      set(value) {
        this.$store.dispatch('setShowLoginSignupBottomSheet', value);
      }
    }

  }
};
</script>

<style>
.sign-up-login-menu-and-buttons {
  height: 100%;
}
</style>